import SummaryCards from "./SummaryCards";
import EnabledAgents from "./EnabledAgents";
import RegisteredAgents from "./RegisteredAgents";
import AgentsRegistrationStatus from "./AgentsRegistrationStatus";
import DashboardOnboardingHeader from "../../common/OnboardingHeader";

const OnboardingStatistics = () => {
  return (
    <>
      <div className="dashboard-page-container">
        <DashboardOnboardingHeader />
        <SummaryCards />
        <div className="row">
          <div className="col-md-6">
            <RegisteredAgents />
          </div>
          <div className="col-md-6">
            <EnabledAgents />
          </div>
          <div className="col-md-6" style={{ marginTop: "4rem" }}>
            <AgentsRegistrationStatus />
          </div>
        </div>
      </div>
    </>
  );
};

export default OnboardingStatistics;
